import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogContent,
    makeStyles,
} from '@material-ui/core';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';
import StringUtils from 'lib/StringUtils';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    previewButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 2,
        backgroundColor: `rgba(${theme.palette.rgb.white},0.5)`,
        '& > button': {
            padding: 0,
            minWidth: 'initial',
            width: '24px',
            '& > span > span': {
                padding: 0,
                margin: 0,
                '& svg': {
                    fill: theme.palette.primary.main,
                },
            },
        },
    },
    appBar: {
        color: theme.palette.text.white,
        backgroundColor: theme.palette.background.sanMarino,
        '& h4': {
            color: theme.palette.text.white,
        },
    },
    previewedImage: {
        overflow: 'hidden',
        '& > img': {
            width: '100%',
        },
    },
}));

const ImagePreview = ({
    imageUrl,
    title,
    children,
    className,
}) => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const hasImage = !StringUtils.isEmpty(imageUrl);

    const openPreview = () => {
        if (!hasImage) return;
        setIsOpen(true);
    };

    const closePreview = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className={className || classes.root}>
                {hasImage && (
                    <div className={classes.previewButton}>
                        <Button
                            startIcon={<VisibilityOutlinedIcon />}
                            onClick={openPreview}
                            aria-label={`Preview ${title}`}
                        />
                    </div>
                )}
                {children}
            </div>
            <Dialog
                open={isOpen}
                maxWidth="md"
                scroll="paper"
                onClose={closePreview}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <DialogAppBar
                    appBarClassName={classes.appBar}
                    title={title}
                    onClose={closePreview}
                    toolbarSize="md"
                />
                <DialogContent className={classes.previewedImage}>
                    {hasImage && (
                        <img
                            alt={title}
                            src={imageUrl}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

ImagePreview.propTypes = {
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
};

ImagePreview.defaultProps = {
    imageUrl: null,
    title: 'Preview',
    children: null,
    className: null,
};

export default ImagePreview;
